import { DEFAULT_FILE_ICON, FILE_ICONS, fileExtension } from '@/lib/fileIcon'
import { formatDate } from '@/lib/formatters'
import type { LossRunDocument } from '@/models/lossRunRequest'
import { DocumentPreviewLink } from './DocumentPreviewLink'
import { FillSectionCard } from './FillSectionCard'

/** Every loss run file on the customer, named as on the Documents tab, its own file name below. */
export function LossRunDocumentsCard({ documents }: { documents: LossRunDocument[] }) {
  const files = documents.flatMap((document) =>
    document.attachments.map((attachment) => ({
      document,
      attachment,
      title: document.attachments.length === 1 ? document.title : attachment.fileName,
    }))
  )
  if (files.length === 0) return null

  return (
    <FillSectionCard title="Loss run documents">
      <ul className="flex flex-col gap-3">
        {files.map(({ document, attachment, title }) => {
          const Icon = FILE_ICONS[fileExtension(attachment.fileName)] ?? DEFAULT_FILE_ICON
          const subline = [
            title === attachment.fileName ? '' : attachment.fileName,
            formatDate(document.dateCreated),
          ]
            .filter(Boolean)
            .join(' · ')
          return (
            <li key={attachment.id} className="flex items-start gap-3 text-sm">
              <Icon className="text-ink-400 mt-0.5 size-4 shrink-0" />
              <div className="flex min-w-0 flex-col">
                <DocumentPreviewLink
                  documentId={document.id}
                  attachmentId={attachment.id}
                  fileName={attachment.fileName}
                  title={title}
                  className="truncate"
                >
                  {title}
                </DocumentPreviewLink>
                <span className="text-ink-500 truncate text-xs">{subline}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </FillSectionCard>
  )
}
